import React from 'react';
import { SkeletonRect, SkeletonText, SkeletonButton } from '../../../common/Skeleton';

const EventFormSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Program Field Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-20']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
      </div>

      {/* Order Field Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-16']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
        <div className="mt-1">
          <SkeletonText widths={['w-48']} height="h-3" />
        </div>
      </div>

      {/* Type Field Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-12']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
      </div>

      {/* Title Field Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-24']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
      </div>

      {/* Description Editor Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-32']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-[280px]" rounded="md" />
      </div>

      {/* Status Toggle Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-16']} height="h-4" />
        </div>
        <div className="flex items-center space-x-3">
          <SkeletonRect width="w-11" height="h-6" rounded="full" />
          <SkeletonText widths={['w-16']} height="h-4" />
        </div>
      </div>

      {/* Date and Time Fields Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-2">
            <SkeletonText widths={['w-24']} height="h-4" />
          </div>
          <SkeletonRect width="w-full" height="h-10" rounded="md" />
        </div>
        <div>
          <div className="mb-2">
            <SkeletonText widths={['w-24']} height="h-4" />
          </div>
          <SkeletonRect width="w-full" height="h-10" rounded="md" />
        </div>
      </div>

      {/* Timezone Field Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-20']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
      </div>

      {/* Thumbnail Section Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-32']} height="h-4" />
        </div>
        <div className="border border-dashed rounded-lg p-6">
          <SkeletonRect width="w-full" height="h-48" rounded="lg" />
        </div>
      </div>

      {/* Buttons Skeleton */}
      <div className="flex flex-col-reverse sm:flex-row gap-3 justify-end">
        <SkeletonButton width="w-full sm:w-auto px-20" height="h-10" rounded="md" />
        <SkeletonButton width="w-full sm:w-auto px-20" height="h-10" rounded="md" />
      </div>
    </div>
  );
};

export default EventFormSkeleton;
